import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-788dfad1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-start items-center" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "deadline text-body-light" }
const _hoisted_5 = { class: "text-body-light" }
const _hoisted_6 = ["title"]

import { computed } from 'vue'
import { useGettext } from 'vue3-gettext'
import formatDate from '@/helpers/formatDate'
import truncate from '@/helpers/truncate'

interface SyncOpItemProps {
  syncOp: SyncOp,
  isSelected: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncOpItem',
  props: {
    syncOp: {},
    isSelected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { $gettext } = useGettext()
const currentLocale = useGettext().current



const deadline = computed(() => formatDate(props.syncOp.deadline, currentLocale))

const summary = computed(
  () => truncate(props.syncOp.description, 100),
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["sync-op item panel", { 'bg-white isSelected': _ctx.isSelected }])
  }, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.syncOp.logo?.contentUrl || 'https://placehold.co/80x80?text=No+Logo',
          alt: "sync opportunity logo"
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.syncOp.title), 1),
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("strong", null, _toDisplayString(_unref($gettext)('Deadline')) + ": " + _toDisplayString(deadline.value), 1)
        ])
      ])
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(summary.value), 1),
    _createElementVNode("footer", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.syncOp.keywords, (keyword) => {
        return (_openBlock(), _createElementBlock("strong", {
          key: keyword.trim(),
          title: keyword,
          class: "tag"
        }, _toDisplayString(keyword), 9, _hoisted_6))
      }), 128))
    ])
  ], 2))
}
}

})